/* NeuroActive side cart + native Shopify checkout. Theme editor settings override CONFIG. */
(function () {
  const CONFIG = {
    targetHandle: 'mindsharp-bundle',
    clearCart: true,
    timerMinutes: 15,
    headerKicker: 'Instant digital access',
    title: 'Complete Your Order',
    timerText: 'Reserved price expires in',
    addOnsLabel: 'Recommended add-ons',
    addOnsBadge: 'Optional',
    checkoutLabel: 'Complete my purchase',
    loadingLabel: 'Preparing checkout...',
    trust: 'Digital delivery. No subscription. 30-day money-back guarantee.',
    secure: 'Secure Shopify checkout - Instant access by email',
    quickCtaLabel: 'I WANT IT NOW',
    drawerAriaLabel: 'Your cart',
    addedLabel: 'Added to order',
    offerAriaPrefix: 'Add',
    fallbackOfferBadge: 'Add-on',
    bundleValueLabel: 'Bundle value',
    todayTotalLabel: 'Today total',
    main: {
      id: 45589061206085,
      productId: 8241744117829,
      productHandle: 'mindsharp-bundle',
      title: 'MindSharp Bundle - 9 Brain Volumes + 4 Free Bonuses',
      image: 'https://cdn.shopify.com/s/files/1/0756/1566/6245/files/ChatGPTImage23ago2026_06_05_21p.m._2.png?v=1787522775',
      price: 2700,
      compare: 7999,
      quantity: 1,
    },
    offers: [],
  };

  const CTA_RE = /ADD\s*TO\s*CART|BUY\s*NOW|I\s*WANT|ORDER\s*NOW|GET\s*(IT|ACCESS|MINE|YOUR)?|CLAIM|CHECKOUT|PURCHASE|COMPLETE|SEND|BUNDLE\s*NOW|INSTANT\s*ACCESS|LO\s*VOGLIO|ACQUISTA|COMPLETA/i;
  const DIRECT_CTA_SELECTOR = '#rc-add-btn,.js-hw-addtocart,.js-bn-addtocart,.js-ts-addtocart,.js-fo-addtocart,#ms-bar-add-btn,button[class*="addtocart"],a[class*="addtocart"],button[id*="add-btn"],a[href*="/cart"],a[href*="/checkout"]';
  const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'ref', 'country', 'market'];
  let busy = false;

  function isThemeEditor() {
    return !!(window.Shopify && window.Shopify.designMode) || document.documentElement.classList.contains('shopify-design-mode');
  }

  function productHandleFromPath() {
    const match = location.pathname.toLowerCase().match(/\/products\/([^/?#]+)/);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (e) {
      return match[1];
    }
  }

  function normalizeHandle(value) {
    return String(value || '').trim().toLowerCase();
  }

  function parseConfig(el) {
    try {
      const config = JSON.parse(el.textContent || '{}');
      config.__sectionId = el.closest('.shopify-section') ? el.closest('.shopify-section').id : '';
      return config;
    } catch (e) {
      return null;
    }
  }

  function readEditorConfig() {
    const configs = Array.from(document.querySelectorAll('[data-nac-config]')).map(parseConfig).filter(Boolean);
    if (!configs.length) return null;
    const currentHandle = normalizeHandle(productHandleFromPath());
    if (!currentHandle) return configs[0];
    return configs.find((config) => {
      const targetHandle = normalizeHandle(config.targetHandle);
      const mainHandle = normalizeHandle(config.main && config.main.productHandle);
      return targetHandle === currentHandle || mainHandle === currentHandle;
    }) || configs[0];
  }

  function asNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function quantity(value) {
    return Math.max(1, Math.round(asNumber(value, 1)));
  }

  function normalizeMain(main) {
    const price = Math.max(0, asNumber(main.price, CONFIG.main.price));
    const compare = Math.max(price, asNumber(main.compare, price));
    return Object.assign({}, main, {
      id: asNumber(main.id, CONFIG.main.id),
      price,
      compare,
      quantity: quantity(main.quantity),
    });
  }

  function normalizeOffers(offers) {
    return (offers || [])
      .map((offer) => {
        const price = Math.max(0, asNumber(offer.price, 0));
        const compare = Math.max(price, asNumber(offer.compare, price));
        return Object.assign({}, offer, {
          id: asNumber(offer.id, 0),
          price,
          compare,
          quantity: quantity(offer.quantity),
          defaultChecked: offer.defaultChecked === true || offer.defaultChecked === 'true',
        });
      })
      .filter((offer) => offer.id > 0 && offer.price > 0);
  }

  function cfg() {
    const override = readEditorConfig();
    const hasOverride = !!override;
    const base = Object.assign({}, CONFIG, hasOverride ? override : {});
    return Object.assign({}, base, {
      main: normalizeMain(Object.assign({}, CONFIG.main, hasOverride && override.main ? override.main : {})),
      offers: normalizeOffers(hasOverride && Array.isArray(override.offers) ? override.offers : CONFIG.offers),
      hasOverride,
    });
  }

  function rootUrl(path) {
    const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
    return root + String(path || '').replace(/^\/+/, '');
  }

  function isTargetPage() {
    const c = cfg();
    if (!c.hasOverride) return false;
    const handle = normalizeHandle(c.targetHandle);
    const currentHandle = normalizeHandle(productHandleFromPath());
    return !!handle && handle === currentHandle;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(Number(cents || 0) / 100);
    } catch (e) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function checkoutUrl() {
    const c = cfg();
    const url = new URL(rootUrl('checkout'), location.origin);
    const now = new URLSearchParams(location.search);
    PARAMS.forEach((key) => {
      const value = now.get(key);
      if (value) url.searchParams.set(key, value);
    });
    if (c.discountCode) url.searchParams.set('discount', c.discountCode);
    return url.pathname + url.search;
  }

  function css() {
    if (document.getElementById('nac-cart-css')) return;
    const style = document.createElement('style');
    style.id = 'nac-cart-css';
    style.textContent = `
      #nac-root{font-family:"DM Sans",Arial,sans-serif;color:#18233d;--nac-navy:#1f2a55;--nac-ink:#18233d;--nac-muted:#5d6982;--nac-line:#dce5ef;--nac-soft:#f4f8fb;--nac-gold:#c79a2b;--nac-lime:#c9dc3f;--nac-green:#2e8540}#nac-root[hidden]{display:none}#nac-root *{box-sizing:border-box}
      #nac-root.is-open{display:block}.nac-ov{position:fixed;inset:0;z-index:99998;background:rgba(31,42,85,.28);backdrop-filter:blur(2px)}
      .nac-drawer{position:fixed;top:0;right:0;z-index:99999;width:min(430px,100vw);height:100dvh;display:flex;flex-direction:column;overflow:hidden;background:linear-gradient(180deg,#fff 0%,#f7f9fc 46%,#eef5f4 100%);border-left:1px solid var(--nac-line);box-shadow:-16px 0 44px rgba(31,42,85,.22);transform:translateX(100%);transition:transform .24s ease}
      #nac-root.is-open .nac-drawer{transform:translateX(0)}.nac-h{display:flex;justify-content:space-between;gap:14px;padding:18px 18px 14px;background:linear-gradient(135deg,#fff 0%,#eef5f4 100%);border-bottom:1px solid var(--nac-line);box-shadow:0 8px 22px rgba(31,42,85,.06)}
      .nac-k{margin:0 0 3px;color:#9a741b;font-size:11px;font-weight:900;letter-spacing:1px;text-transform:uppercase}.nac-title{margin:0;color:var(--nac-navy);font-family:"Bebas Neue",Impact,sans-serif;font-size:32px;font-weight:400;line-height:.95;letter-spacing:0}
      .nac-x{width:34px;height:34px;border:1px solid var(--nac-line);border-radius:8px;background:#fff;color:var(--nac-navy);font-weight:900;cursor:pointer;box-shadow:0 4px 12px rgba(31,42,85,.08)}.nac-timer{display:flex;justify-content:center;gap:7px;padding:10px 16px;background:#edf8ef;border-bottom:1px solid #cfe5d5;color:#2d3b59;font-size:13px;font-weight:800}.nac-timer b{color:var(--nac-green);font-variant-numeric:tabular-nums}
      .nac-body{flex:1;overflow:auto;padding:14px;background:linear-gradient(180deg,#f8fafc 0%,#eef5f4 100%)}.nac-main,.nac-offer{display:flex;align-items:center;gap:12px;background:#fff;border:1px solid var(--nac-line);border-radius:8px;box-shadow:0 8px 22px rgba(31,42,85,.08)}.nac-main{padding:13px;border-color:#ead89b;background:#fffdf7}.nac-img{width:74px;height:74px;object-fit:cover;background:#fff;border:1px solid #e5d38d;border-radius:7px}.nac-copy{min-width:0;flex:1}
      .nac-badge,.nac-ob{display:inline-flex;width:max-content;margin-bottom:6px;padding:5px 9px;border-radius:999px;font-size:10px;font-weight:900;line-height:1;text-transform:uppercase;letter-spacing:.3px}.nac-badge{background:var(--nac-navy);color:#fff}.nac-ob{background:#edf7d7;color:var(--nac-navy);border:1px solid #d9eaa8}.nac-copy h3{margin:0;color:var(--nac-ink);font-size:13px;font-weight:900;line-height:1.25;letter-spacing:0}.nac-price{display:flex;align-items:baseline;gap:8px;margin-top:7px;color:var(--nac-navy)}.nac-price b{font-family:"Bebas Neue",Impact,sans-serif;font-size:28px;font-weight:400;line-height:1}.nac-price s{color:#8792aa;font-size:12px;font-weight:800}
      .nac-oh{display:flex;justify-content:space-between;margin:15px 2px 9px;color:#2d3b59;font-size:11px;font-weight:900;letter-spacing:1px;text-transform:uppercase}.nac-oh em{font-style:normal;color:#7a5709;background:#fff3cb;border:1px solid #ecd681;border-radius:999px;padding:4px 10px}.nac-list{display:grid;gap:9px}.nac-offer{position:relative;padding:10px;transition:.16s}.nac-offer.on{background:#f6fbea;border-color:var(--nac-lime);box-shadow:0 10px 24px rgba(143,160,40,.18)}
      .nac-check{width:25px;height:25px;display:grid;place-items:center;flex:0 0 auto;border:2px solid #bcc9da;border-radius:6px;background:#fff;color:var(--nac-navy);cursor:pointer}.nac-offer.on .nac-check{background:var(--nac-lime);border-color:#a8bc2e}.nac-offer.on .nac-check:before{content:"\\2713";font-size:16px;font-weight:900}.nac-oi{width:58px;height:58px;object-fit:cover;background:#fff;border:1px solid #e1e8f1;border-radius:7px}.nac-copy p{margin:4px 0 0;color:var(--nac-muted);font-size:11px;font-weight:600;line-height:1.35;letter-spacing:0}.nac-smallprice b{font-size:15px;font-family:inherit;font-weight:900}.nac-qty{color:var(--nac-green);font-size:11px;font-weight:900}.nac-input{position:absolute;opacity:0;pointer-events:none}
      .nac-trust{margin-top:14px;color:var(--nac-muted);font-size:11px;font-weight:700;text-align:center;line-height:1.45}.nac-f{padding:13px 14px 16px;background:#fff;border-top:1px solid var(--nac-line);box-shadow:0 -10px 24px rgba(31,42,85,.08)}.nac-lines{display:grid;gap:6px;margin-bottom:12px}.nac-lines div{display:flex;justify-content:space-between;color:#34415f;font-size:12px;font-weight:800}.nac-lines .nac-total{color:var(--nac-navy);font-size:17px}.nac-total b{font-family:"Bebas Neue",Impact,sans-serif;font-size:31px;font-weight:400;line-height:1}
      .nac-btn{width:100%;min-height:52px;border:0;border-radius:8px;background:linear-gradient(135deg,#2e8540,#6abf43);box-shadow:0 12px 28px rgba(46,133,64,.24);color:#fff;cursor:pointer;font-size:14px;font-weight:900;line-height:1.15;padding:15px 18px;text-transform:uppercase}.nac-btn:disabled{opacity:.72;cursor:wait}.nac-sec{margin:8px 0 0;color:#69758d;font-size:11px;font-weight:700;text-align:center}
      @media(max-width:480px){.nac-drawer{width:100vw}.nac-h{padding:16px 14px 12px}.nac-title{font-size:29px}.nac-body{padding:12px}.nac-img{width:68px;height:68px}.nac-copy h3{font-size:12.5px}}
    `;
    document.head.appendChild(style);
  }

  function markup() {
    const c = cfg();
    const offers = c.offers
      .map((o, i) => {
        const offerTotal = o.price * o.quantity;
        const offerCompare = o.compare * o.quantity;
        return `
        <article class="nac-offer${o.defaultChecked ? ' on' : ''}" data-i="${i}">
          <button class="nac-check" type="button" aria-label="${escapeHtml(c.offerAriaPrefix)} ${escapeHtml(o.title)}"></button>
          <img class="nac-oi" src="${o.image}" alt="${escapeHtml(o.title)}" loading="lazy">
          <div class="nac-copy">
            <span class="nac-ob">${escapeHtml(o.badge || c.fallbackOfferBadge)}</span>
            <h3>${escapeHtml(o.title)}</h3>
            <p>${escapeHtml(o.description || '')}</p>
            <div class="nac-price nac-smallprice"><b>${money(offerTotal)}</b>${offerCompare > offerTotal ? `<s>${money(offerCompare)}</s>` : ''}${o.quantity > 1 ? `<span class="nac-qty">x${o.quantity}</span>` : ''}</div>
          </div>
          <input class="nac-input" type="checkbox" data-offer data-variant="${o.id}" data-price="${o.price}" data-compare="${o.compare || o.price}" data-quantity="${o.quantity}" ${o.defaultChecked ? 'checked' : ''}>
        </article>`;
      })
      .join('');
    const mainQuantity = quantity(c.main.quantity);
    const mainTotal = Number(c.main.price || 0) * mainQuantity;
    const mainCompare = Number(c.main.compare || c.main.price || 0) * mainQuantity;

    return `
      <div id="nac-root" hidden>
        <div class="nac-ov" data-close></div>
        <aside class="nac-drawer" role="dialog" aria-modal="true" aria-label="${escapeHtml(c.drawerAriaLabel)}">
          <header class="nac-h"><div><p class="nac-k">${escapeHtml(c.headerKicker)}</p><h2 class="nac-title">${escapeHtml(c.title)}</h2></div><button class="nac-x" type="button" data-close>x</button></header>
          <div class="nac-timer"><span>${escapeHtml(c.timerText)}</span><b data-time>15:00</b></div>
          <div class="nac-body">
            <article class="nac-main"><img class="nac-img" src="${c.main.image}" alt="${escapeHtml(c.main.title)}" loading="lazy"><div class="nac-copy"><span class="nac-badge">${escapeHtml(c.addedLabel)}</span><h3>${escapeHtml(c.main.title)}</h3><div class="nac-price"><b>${money(mainTotal)}</b>${mainCompare > mainTotal ? `<s>${money(mainCompare)}</s>` : ''}${mainQuantity > 1 ? `<span class="nac-qty">x${mainQuantity}</span>` : ''}</div></div></article>
            <div class="nac-oh"><span>${escapeHtml(c.addOnsLabel)}</span><em>${escapeHtml(c.addOnsBadge)}</em></div>
            <div class="nac-list">${offers}</div>
            <div class="nac-trust">${escapeHtml(c.trust)}</div>
          </div>
          <footer class="nac-f"><div class="nac-lines"><div><span>${escapeHtml(c.bundleValueLabel)}</span><b data-save>$0.00</b></div><div class="nac-total"><span>${escapeHtml(c.todayTotalLabel)}</span><b data-total>${money(mainTotal)}</b></div></div><button class="nac-btn" type="button" data-checkout data-native-checkout-ignore>${escapeHtml(c.checkoutLabel)}</button><p class="nac-sec">${escapeHtml(c.secure)}</p></footer>
        </aside>
      </div>`;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (x) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[x]));
  }

  function ensure() {
    if (!document.getElementById('nac-root')) {
      css();
      document.body.insertAdjacentHTML('beforeend', markup());
      bind();
    }
    totals();
    timer();
    return document.getElementById('nac-root');
  }

  function bind() {
    const r = document.getElementById('nac-root');
    r.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', close));
    r.querySelectorAll('.nac-offer').forEach((card) => {
      card.addEventListener('click', () => {
        const input = card.querySelector('[data-offer]');
        input.checked = !input.checked;
        totals();
      });
    });
    r.querySelector('[data-checkout]').addEventListener('click', checkout);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  }

  function selected() {
    return Array.from(document.querySelectorAll('#nac-root [data-offer]')).filter((x) => x.checked);
  }

  function totals() {
    const c = cfg();
    const mainQuantity = quantity(c.main.quantity);
    let total = Number(c.main.price || 0) * mainQuantity;
    let compare = Number(c.main.compare || c.main.price || 0) * mainQuantity;
    document.querySelectorAll('#nac-root .nac-offer').forEach((card) => {
      const input = card.querySelector('[data-offer]');
      card.classList.toggle('on', !!input.checked);
      if (input.checked) {
        const itemQuantity = quantity(input.dataset.quantity);
        total += Number(input.dataset.price || 0) * itemQuantity;
        compare += Number(input.dataset.compare || input.dataset.price || 0) * itemQuantity;
      }
    });
    const t = document.querySelector('#nac-root [data-total]');
    const s = document.querySelector('#nac-root [data-save]');
    if (t) t.textContent = money(total);
    if (s) s.textContent = money(Math.max(compare - total, 0));
  }

  function timer() {
    const el = document.querySelector('#nac-root [data-time]');
    if (!el || el.dataset.started) return;
    el.dataset.started = '1';
    const minutes = Math.max(Number(cfg().timerMinutes || 15), 1);
    const key = 'nac_timer_end';
    let end = Number(sessionStorage.getItem(key) || 0);
    if (!end || end < Date.now()) {
      end = Date.now() + minutes * 60000;
      sessionStorage.setItem(key, String(end));
    }
    function tick() {
      const left = Math.max(0, Math.round((end - Date.now()) / 1000));
      el.textContent = `${String(Math.floor(left / 60)).padStart(2, '0')}:${String(left % 60).padStart(2, '0')}`;
      if (left > 0) setTimeout(tick, 1000);
    }
    tick();
  }

  function open() {
    const r = ensure();
    r.hidden = false;
    requestAnimationFrame(() => {
      r.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  function close() {
    const r = document.getElementById('nac-root');
    if (!r) return;
    r.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => {
      if (!r.classList.contains('is-open')) r.hidden = true;
    }, 250);
  }

  function trigger(el) {
    if (!el || el.closest('#nac-root,[data-native-checkout-ignore]')) return false;
    if (el.matches(DIRECT_CTA_SELECTOR)) return true;
    if (el.closest('#stickybar-mindsharp')) return true;
    const href = el.getAttribute && el.getAttribute('href');
    if (/\/cart(?:\/|\?|$)|\/checkout(?:\/|\?|$)/i.test(href || '')) return true;
    if (el.matches('[name="add"],[type="submit"],.shopify-payment-button__button') || el.closest('product-form,.product-form__buttons,form[data-type="add-to-cart-form"]')) return true;
    return !!(el.closest('#MainContent') && CTA_RE.test((el.textContent || el.value || '').replace(/\s+/g, ' ')));
  }

  function intercept(e, el) {
    if (isThemeEditor() || !isTargetPage() || busy || !trigger(el)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open();
  }

  function takeoverCtas() {
    if (isThemeEditor() || !isTargetPage()) return;
    document.querySelectorAll(DIRECT_CTA_SELECTOR).forEach((el) => {
      if (el.dataset.nacBound === '1') return;
      el.dataset.nacBound = '1';
      if (el.tagName === 'BUTTON') el.setAttribute('type', 'button');
    });
  }

  function watchCtas() {
    takeoverCtas();
    let ticks = 0;
    const interval = setInterval(() => {
      takeoverCtas();
      ticks += 1;
      if (ticks > 10) clearInterval(interval);
    }, 750);
    if ('MutationObserver' in window) {
      const observer = new MutationObserver(() => takeoverCtas());
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  async function post(path, body) {
    return fetch(rootUrl(path), {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    });
  }

  function items() {
    const c = cfg();
    const list = [{ id: Number(c.main.id), quantity: quantity(c.main.quantity), price: c.main.price, title: c.main.title }];
    selected().forEach((i) => list.push({
      id: Number(i.dataset.variant),
      quantity: quantity(i.dataset.quantity),
      price: Number(i.dataset.price || 0),
      title: i.closest('.nac-offer').querySelector('h3').textContent.trim(),
    }));
    return list;
  }

  function fallback(list) {
    const lines = list.map((i) => `${i.id}:${i.quantity}`).join(',');
    return `${rootUrl(`cart/${lines}`)}?return_to=${encodeURIComponent(checkoutUrl())}`;
  }

  function track(list) {
    const value = list.reduce((n, i) => n + (Number(i.price || 0) * Number(i.quantity || 1)) / 100, 0);
    try {
      if (typeof fbq === 'function') fbq('track', 'InitiateCheckout', { value, currency: 'USD', content_ids: list.map((i) => String(i.id)) });
    } catch (e) {}
  }

  async function checkout() {
    const c = cfg();
    const btn = document.querySelector('#nac-root [data-checkout]');
    const list = items();
    busy = true;
    if (btn) {
      btn.disabled = true;
      btn.textContent = c.loadingLabel;
    }
    track(list);
    try {
      if (c.clearCart !== false) await post('cart/clear.js');
      const res = await post('cart/add.js', { items: list.map((i) => ({ id: i.id, quantity: i.quantity })) });
      if (!res.ok) throw new Error('Cart add failed');
      location.href = checkoutUrl();
    } catch (e) {
      location.href = fallback(list);
    }
  }

  function relabel() {
    if (isThemeEditor() || !isTargetPage()) return;
    const label = cfg().quickCtaLabel || 'I WANT IT NOW';
    document.querySelectorAll('[id^="ProductSubmitButton-"] span,product-form button[name="add"] span,#stickybar-mindsharp .ms-bar-btn-text').forEach((x) => {
      if (!x.classList.contains('sold-out-message')) x.textContent = label;
    });
  }

  function clickHandler(e) {
    const el = e.target instanceof Element ? e.target.closest('button,a,input[type="submit"],[role="button"]') || e.target.closest('#stickybar-mindsharp') : null;
    intercept(e, el);
  }

  function submitHandler(e) {
    intercept(e, e.submitter || e.target);
  }

  function init() {
    if (isThemeEditor()) {
      window.NeuroCartDrawer = { open: function () {}, close: function () {}, refresh: function () {} };
      return;
    }
    document.addEventListener('submit', submitHandler, true);
    document.addEventListener('click', clickHandler, true);
    window.NeuroCartDrawer = { open, close, refresh: totals };
    window.openCart = open;
    window.closeCart = close;
    relabel();
    watchCtas();
    if (isTargetPage()) ensure();
  }

  document.addEventListener('shopify:section:load', () => {
    if (isThemeEditor()) return;
    const root = document.getElementById('nac-root');
    if (root) root.remove();
    if (isTargetPage()) ensure();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
